import { t } from "i18next";
import {IPineconeQueryItemResult} from "./pinecone";

export interface IOptionType {
    value: string;
    label: string;
}

export enum matchActions {
    match = "match",
    unmatch = "unmatch",
}

export enum FetchOptionType {
    Manufacturer = "manufacturers",
    ItemGroups = "itemGroups",
    ItemMPOptions = "itemMPOptions",
}

export interface IResultMetadataModel {
    FileName: string;
    BrandNo: string;
    DocName: string;
    ArtNo: string;
    GenArtNo: string;

    [propName: string]: any;
}

export interface IDropFileModel {
    id?: string;
    fileobject: File;
    preview: string;
    pineconeResult?: IPineconeQueryItemResult;
}

export const partPositionDatabaseNamespaceValue = "PartPosition";

export const databaseNamespaceOptions: IOptionType[] = [
    { value: "TM", label: t("Filter.imageTypeTMLabel") },
    { value: "BTL", label: t("Filter.imageTypeBTLLabel") },
]